import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatLegacySnackBarModule as MatSnackBarModule } from '@angular/material/legacy-snack-bar';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { ButtonModule } from '@studiobuki/web-core/lib/button';
import { CardModule } from '@studiobuki/web-core/lib/card';
import { BlockSnsCardComponent } from './components/block-sns-card/block-sns-card.component';
import { CopyPlateComponent } from './components/copy-plate/copy-plate.component';
import { ContentComponent } from './content.component';

@NgModule({
  declarations: [ContentComponent, CopyPlateComponent, BlockSnsCardComponent],
  imports: [
    CommonModule,
    RouterModule,
    ButtonModule,
    MatSnackBarModule,
    CardModule,
    AngularSvgIconModule,
  ],
  exports: [ContentComponent],
})
export class ContentModule {}
